<template>
  <div class="search">
       <el-tabs type="border-card"  class="search-input"  v-model="searchType">
        <el-autocomplete
          v-model="content"
          placeholder="Search"
          prefix-icon="Search"
          style="width: 100%"
          size="large"
          class="search-input-text"
          inline-style="background-color: #f0f0f0;"
          @select="handleSelectSearchSiteUrl"
          @keyup.enter="handleSearchUrl('/search/')"
          :fetch-suggestions="handleSearchSiteData"
        >
          <template #append>
            <el-button  @click="handleSearchUrl('/search/')"
              > <svg-icon icon-name="search" class="little" /></el-button
            >
          </template>
        </el-autocomplete>
    </el-tabs>
  </div>
</template>
<script setup>
import { getCurrentInstance, ref } from 'vue'
import { siteDomain } from '@/config/setting.config'
import { siteList } from '@/api/client/search'
import { updateClickCount } from '@/api/nav/site'
import { openSite } from '@/utils/geshanzsq'
const { proxy } = getCurrentInstance()

const searchType = ref('site')
const content = ref()

/**
 * 搜索按钮或选择事件
 */
function handleSearchUrl(url) {
  if (!content.value) {
    proxy.$modal.msgWarning('Please input the content!')
    return
  }
  openSite(url + content.value)
}

/**
 * 点击站内搜索的网站
 */
function handleSelectSearchSiteUrl(site) {
  // 设置输入框内容为之前输入的内容，否则点击后会取 value 值
  content.value = site.searchContent
  openSite('/detail/get/' + site.id)
  // 更新点击量
  updateClickCount(site.id)
}

/**
 * 搜索站内网站
 */
async function handleSearchSiteData(searchContent, cb) {
  const searchList = []
  if (!searchContent) {
    cb(searchList)
    return
  }
  const { data } = await siteList(content.value, siteDomain)
  data.forEach((site) => {
    searchList.push({
      id: site.id,
      searchContent: searchContent,
      siteUrl: site.siteUrl,
      value:
        '【' +
        site.categoryName +
        '】' +
        site.siteName +
        '-' +
        site.siteDescription
    })
  })
  cb(searchList)
}
</script>

<style lang="scss">
.search {
 cursor: pointer;
  margin-top:8px;
  border-radius: 15px;
  background: rgba(222,222,221,0.5);
  color: #fff;
  .little{
                   width: 1.7em;
                   height: 1.7em;
                    margin-right: 20px;
                    margin-top:0px;
                  }
  .search-input {
     background-color: transparent;
     border: none;
     flex-direction: unset;
      .search-input-text .el-input__inner
      {
          color: gray;
          font-size: 20px;
      }
     .search-input-text .el-input__wrapper{
        border-radius: 15px;
        width:100%;
        }
        .el-input-group__append {
            background-color: transparent;
            border: none;
            color: var(--el-color-white);
            width: 70px;
            box-shadow: none;
            border-radius: 15px;

        }
  }
}
</style>
